
            const data = {"name":"success","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m9 12 2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z\" _stroke=\"#10B50D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#10B50D"}],"stopColors":[]}}
        
                    module.exports = data
                    